import styled from 'styled-components';
import { FontAddiWeightBold, FontAddiWeightRegular, FontAddiWeightSemiBold, } from '@addi/foundation/dist/web/fonts';
import { SizeAddiFontBase, SizeAddiFontXSmall } from '@addi/foundation/dist/web/sizes';
import { LayoutAddiScreenMobileLargeMax } from '@addi/foundation/dist/web/layout';
import { Header1, Paragraph } from '../../components/typographies';
import { ColorAddiWhite } from '@addi/foundation/dist/web/colors';
export const ItemContainer = styled.div `
  padding: 0;
  cursor: pointer;
  display: inline-block;
  text-align: center;
`;
export const ImageContainer = styled.div `
  border-radius: 100%;
  width: ${({ sizeMobile }) => (sizeMobile ? `${sizeMobile}px` : '80px')};
  height: ${({ sizeMobile }) => (sizeMobile ? `${sizeMobile}px` : '80px')};
  margin: 0 auto;
  left: 0;
  right: 0;
  background-image: ${({ backgroundImage }) => `url(${backgroundImage})`};
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  @media (min-width: ${LayoutAddiScreenMobileLargeMax}) {
    width: ${({ sizeDesktop }) => (sizeDesktop ? `${sizeDesktop}px` : '124px')};
    height: ${({ sizeDesktop }) => (sizeDesktop ? `${sizeDesktop}px` : '124px')};
  }
`;
export const TextCategory = styled(Header1) `
  margin: 0;
  margin-top: 8px;
  font-size: ${SizeAddiFontXSmall};
  font-weight: ${({ small }) => (small ? FontAddiWeightRegular : FontAddiWeightSemiBold)};
  line-height: 20.72px;

  @media (min-width: ${LayoutAddiScreenMobileLargeMax}) {
    margin-top: 18.95px;
    line-height: 28.8px;
    font-size: ${SizeAddiFontBase};
    font-weight: ${({ small }) => (small ? FontAddiWeightRegular : FontAddiWeightBold)};
  }
`;
export const ItemMoreContainer = styled.div `
  padding: 0;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  align-items: center;
  background-color: ${ColorAddiWhite};
  width: 100%;
`;
export const ImageContainerMoreCat = styled(ImageContainer) `
  margin: 16px 8px 16px 16px;
`;
export const TextMoreCategory = styled(Paragraph) `
  margin: 0;
  font-weight: ${FontAddiWeightRegular};
  font-size: 12px;
  line-height: 16.32px;

  @media (min-width: ${LayoutAddiScreenMobileLargeMax}) {
    line-height: 32px;
    font-size: ${SizeAddiFontBase};
  }
`;
//# sourceMappingURL=category-item.styles.js.map